import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerPsiquiatria'; 
import AboutNeurologista from './AboutPsiquiatria';
import CorpoClinico from './CorpoClinicoPsiquiatria';
import "../../styles/psicomotricidade.css"
import "../../styles/footer.css";

const About = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutNeurologista />
        <CorpoClinico />
      </div>
    );
  };
  
  export default About;
  